import types from '../types'
import 'firebase/compat/database'

export const getTools = (database) => async (dispatch) => {
  const dbRef = database.ref(`tools`)

  await dbRef.on(
      'value',
      (snapshot) => {
        const val = snapshot.val()
        const tools = val
        dispatch({
          type: types.STORE_PAYLOAD,
          payload: {
            tools,
          },
        })
      },
      (errorObject) => console.log(errorObject),
  )
}
